"use client";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import { useEffect } from "react";

function ChannelTalk() {
  useEffect(() => {
    ChannelService.loadScript();
    ChannelService.boot({
      pluginKey: "b22ba07e-d567-47b8-ae93-470c062ec013",
    });

    return () => {
      ChannelService.shutdown();
    };
  }, []);

  return <></>;
}

export default ChannelTalk;
